import { render, staticRenderFns } from "./partButton.vue?vue&type=template&id=3c1d8d72"
import script from "./partButton.vue?vue&type=script&lang=js"
export * from "./partButton.vue?vue&type=script&lang=js"
import style0 from "./partButton.vue?vue&type=style&index=0&id=3c1d8d72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports